import { useCallback } from 'react';
import { getQueryParamsByName, navigate, useFormatDate } from '@hwm/ui-lib';
import { FiltersPeriodModel } from '@shared/models';

export const usePeriodFilterState = () => {
  const filterState = getQueryParamsByName({ from: 'from', to: 'to' });

  const { formatDate } = useFormatDate();

  const setPeriodFilter = useCallback(
    (range: [Date, Date]) => {
      navigate({
        keepPreviousParams: true,
        pushToState: false,
        search: {
          from: range ? formatDate(range[0], 'yyyy-MM-dd_HH.mm') : null,
          to: range ? formatDate(range[1], 'yyyy-MM-dd_HH.mm') : null,
        },
      });
    },
    [formatDate]
  );

  const formatDateFromURL = (date: string): string => {
    const [datePart, hoursPart] = date?.split('_') ?? [];
    return date ? `${datePart}T${hoursPart.replace('.', ':')}` : '';
  };

  const periodState = {
    from: formatDateFromURL(filterState.from),
    to: formatDateFromURL(filterState.to),
  } as FiltersPeriodModel;

  return {
    periodState,
    setPeriodFilter,
  };
};
